import {
    AccountId as IoTsAccountId,
    BankId as IoTsBankId,
    CardId as IoTsCardId,
    CountryCode as IoTsCountryCode,
    CurrencyCode as IoTsCurrencyCode,
    Iban as IoTsIban,
    DoubleString as IoTsNDoubleString,
    NonNegativeDoubleString as IoTsNonNegativeDoubleString,
    NonNegativeInt as IoTsNonNegativeInt,
    Source as IoTsSource,
    VirtualIban as IoTsVirtualIban,
} from '@raison/types';
import {type} from 'arktype';

export const AccountId = type('number').as<IoTsAccountId>();
export type AccountId = typeof AccountId.infer;

export const PaymentCardId = type('number').as<IoTsCardId>();
export type PaymentCardId = typeof PaymentCardId.infer;

export const PaymentNetworkId = type('number | string').as<IoTsBankId>();
export type PaymentNetworkId = typeof PaymentNetworkId.infer;

export const MethodType = type("'card' | 'payment_network'");
export type MethodType = typeof MethodType.infer;

export const MethodId = type(PaymentCardId).or(PaymentNetworkId);
export type MethodId = typeof MethodId.infer;

export const TopupRequisiteId = type('number');
export type TopupRequisiteId = typeof TopupRequisiteId.infer;

export const NonNegativeInt = type('number.integer >= 0').as<IoTsNonNegativeInt>();
export type NonNegativeInt = typeof NonNegativeInt.infer;

export const CountryCode = type('string').as<IoTsCountryCode>();
export type CountryCode = typeof CountryCode.infer;

export const CurrencyCode = type('string').as<IoTsCurrencyCode>();
export type CurrencyCode = typeof CurrencyCode.infer;

export const NonNegativeDoubleString = type('string').filter(input => IoTsNonNegativeDoubleString.is(input));
export type NonNegativeDoubleString = typeof NonNegativeDoubleString.infer;

export const DoubleString = type('string').filter(input => IoTsNDoubleString.is(input));
export type DoubleString = typeof DoubleString.infer;

export const Source = type('string').as<IoTsSource>();
export type Source = typeof Source.infer;

export const ProviderId = type('number.integer');
export type ProviderId = typeof ProviderId.infer;

export const TargetStatus = type("'verified' | 'not_verified' | 'pending'");
export type TargetStatus = typeof TargetStatus.infer;

export const VirtualIban = type('string').as<IoTsVirtualIban>();
export type VirtualIban = typeof VirtualIban.infer;

export const Iban = type('string').as<IoTsIban>();
export type Iban = typeof Iban.infer;
